function AccountsCtrl($scope, $filter, $state, $timeout, DateTimeService, AccountItemService, EntityTypesService){
    $scope.$root.dividedInner = true;
    var $window = $(window);

    let currentTags = null;

    $scope.tableConfig = {
        searchDelay: 700,
        class: 'accounts-table',
        dataURL : function(){
            if (!$scope.tableConfig.viewType) {
                return null;
            }
            return "/accounts?accountId=" + $scope.params.accountId+"&showMe=false&onlyReseller=false&viewType="+$scope.tableConfig.viewType;
        },
        titleSearch: 'Accounts',
        parseData: function(dataItems){
            dataItems = dataItems || [];

            dataItems.forEach(function(dataItem){
                AccountItemService.parseItemData(dataItem);
            });

            $scope.tableConfig.maxThroughputTotal = 0;
            var fieldName = "throughputTotal";

            dataItems.forEach(function(dataItem){
                if(dataItem.realtimeStats && dataItem.realtimeStats[0] && dataItem.realtimeStats[0].rtStatsList && dataItem.realtimeStats[0].rtStatsList.length > 0){
                    dataItem.realtimeStats[0].rtStatsList.forEach(function(value){
                        value[fieldName] = value.throughputReceived + value.throughputSent;
                        if (value.throughputTotal && value.throughputTotal > $scope.tableConfig.maxThroughputTotal){
                            $scope.tableConfig.maxThroughputTotal = value[fieldName];
                        }
                    });
                }
            });

            return dataItems;
        },
        addURL : function(item) {
            return "/" + $scope.params.accountId + "/addAccount?inline=showAddAccount&parent=accounts&accountId=" + $scope.params.accountId;
        },
        changeView : function(mode) {
            $state.go($state.current.name, {
                mode: mode,
                searchVal: $scope.tableConfig.searchVal
            }, {
                location: true,
            });
        },
        searchVal: $state.params.searchVal || '',
        sortList : [{sortField: "name", sortDir: "ASC" }],
        sortButton: true,
        type : "Account",
        showLoader: true,
        actions: ["add","remove"],
        getProductionClass: function(value){
            return ((value ==='PRODUCTION') ? 'saved' : 'delete') + ' icon icon-'+ ((value ==='PRODUCTION') ? 'saved' : 'x');
        },
        getProductionIcon: function(value){
            return '/public/images/icons/main.svg#icon-'+((value ==='PRODUCTION') ? 'saved' : 'x');
        },
        tagsConfig : {
            dataURL : function(){
                if(isSystemLogin){
                    return "/tags"
                }
            },
            fields : [{"label":"Name","path":"name","template":"<span>{{item}}</span>"}
            ],
            parseData: function(dataItems){
                if(!dataItems){
                    return;
                }
                var result = [];
                dataItems.forEach(function(dataItem){
                    result.push(dataItem.name);
                });
                return result;
            },
            actions: [],
            selectedItems:[],
            selectIdentifier:"item"
        },
        addTags: function() {
            $scope.selectedAccount.tags = [];

            $scope.tableConfig.tagsConfig.selectedItems.forEach(function(tag) {
                $scope.selectedAccount.tags.push(tag);
            });

            $scope.selectedAccount.newSaveMethod = true;
            store.save({
                data: $scope.selectedAccount,
                dataObj: 'json',
                path: "/edit",
                queryParams: {
                    'accountId': $scope.selectedAccount.id || null,
                    'save':true,
                    'fields':"['tags']"
                },
                success: function(data) {
                    $scope.$root.handleServerResponse(data,"", "Account settings saved successfully");
                    EntityTypesService.clearCache(); // since tags can change the entity types for an account we should clear this service cache after changing account tags
                    $scope.datamodified = new Date().getTime();
                    $scope.$root.closePopup('tagsDlg');
                }
            });
        },
        showTagsPopUp : function(item,field,id){
            $scope.selectedAccount = item;
            $scope.tableConfig.tagsConfig.selectedItems = [];
            $scope.selectedAccount.tags.forEach(function(tag) {
                $scope.tableConfig.tagsConfig.selectedItems.push(tag);
            });
            currentTags = angular.copy($scope.tableConfig.tagsConfig.selectedItems);
            $scope.$root.openPopup("tagsDlg");
        },
        chartsSettings: {
            "type": "serial",
            fontFamily: 'Roboto',
            addClassNames: true,
            "path": "/public/javascripts/external/amcharts/",
            "pathToImages": "/public/javascripts/external/amcharts/images/",
            "categoryField": "sampleTime",
            theme: "new",
            autoMarginOffset: 10,
            "categoryAxis":{
                gridAlpha: 0.15,
                "minPeriod": "2500fff",
                markPeriodChange: true,
                "parseDates": true,
                dateFormats: [{period:'fff',format:'JJ:NN:SS'},{period:'ss',format:'JJ:NN:SS'},{period:'mm',format:'JJ:NN'},{period:'hh',format:'JJ:NN'},{period:'DD',format:'MMM DD'},{period:'WW',format:'MMM DD'},{period:'MM',format:'MMM'},{period:'YYYY',format:'YYYY'}]

            },
            "chartCursor": {
                cursorPosition: "mouse",
                selectWithoutZooming: true,
                "categoryBalloonDateFormat": "JJ:NN:SS, MMM DD, YYYY"
            },
            "trendLines": [],
            "legend":  {
                position: "absolute",
                useGraphSettings: true,
                enabled: false,
                valueText: ""
            },
            "graphs": [
                {
                    "lineThickness": 2,
                    "dateFormat": "JJ:NN:SS DD, YYYY",
                    "fillAlphas": 0.33,
                    "fontSize": 4,
                    "id": "AmGraph-1",
                    "title": "Account",
                    "valueField": "throughputTotal",
                    valueAxis: "ValueAxis-1",
                    balloonFunction: function (graphDataItem) {
                        return $filter('bits')(graphDataItem.values.value, 1) + "ps";
                    }
                }
            ],
            "guides": [],
            "valueAxes": [
                {
                    "id": "ValueAxis-1",
                    "title": "Throughput",
                    labelsEnabled: true,
                    titleFontSize: 10,
                    "gridAlpha": 0,
                    "axisAlpha": 1,
                    "axisThickness": 2,
                    labelFunction: function(value){
                        return $filter('bits')(value, 1) + 'ps';
                    }
                }
            ],
            "allLabels": [],
            "export": {
                "enabled": true
            }
        },
        fixedLayout: true,
    };



    function init(defered) {
        if (!$scope.$root || !$scope.$root.tags) {
            $timeout(function() {
                init(true);
            }, 20, false);
            return;
        }

        if (isSystemLogin) {
            changeView($state.params.mode || 'List');
        } else {
            changeView('Card');
        }
        if (defered) {
            $timeout(function() {
                $scope.datamodified = new Date().getTime();
            }, 1);
        }
    }

    init(false);

    $scope.throughputChart = {};

    $scope.$watch("searchEntities", function(newVal, oldVal){
        if(newVal !== oldVal){
            $scope.$root.updateScroll('#accountOptions .nano');
        }
    });

    $scope.tableConfig.specialActions = [];

    if(isSystemLogin || isResellerLogin){
        $scope.isSystemLogin = isSystemLogin ? true : undefined;
        //add move accounts action
        $scope.tableConfig.specialActions = [
            {"icon":"transfer",tooltip:"Move under reseller", id:"list-more-accountsTbl","func":function(selectedItems) {
                var targetElId = 'list-more-accountsTbl';
                if($('#'+targetElId).hasClass('open')){
                    $scope.closeFilterDlg(targetElId);
                }
                else{
                    $scope.openMoveAccountDlg(targetElId,selectedItems);
                }
            }},
            {"icon":"transfer",tooltip:"Rename Account", id:"list-more-accountsTbl","func":function(selectedItems) {
                var targetElId = 'list-more-accountsTbl';
                if($('#'+targetElId).hasClass('open')){
                    $scope.closeAccountRenameDlg(targetElId);
                }
                else{
                    $scope.openNewNameDlg(targetElId,selectedItems);
                }
            }}
        ];
    }


    if ($scope.$root.externalVlan || isSystemLogin) {
//        $scope.tableConfig.specialActions.push({"icon":"transfer",tooltip:"Set VLAN", id:"list-more-accountsTbl","func":function(selectedItems) {
//            var targetElId = 'list-more-accountsTbl';
//            if($('#'+targetElId).hasClass('open')){
//                $scope.closeVlanDlg(targetElId);
//            }
//            else{
//                $scope.openVlanDlg(targetElId,selectedItems);
//            }
//        }});
//        $scope.tableConfig.specialActions.push({"icon":"transfer",tooltip:"Remove VLAN", id:"list-more-accountsTbl","func":function(selectedItems) {
//            $scope.removeVlan(selectedItems);
//        }});
        $scope.tableConfig.specialActions.push({"icon":"transfer",tooltip:"Cross Connect Settings", id:"list-more-accountsTbl","func":function(selectedItems) {
            var targetElId = 'list-more-accountsTbl';
            $scope.openCrossConnectDlg(targetElId,selectedItems);
        }});
    }

    $scope.openNewNameDlg = function(targetElId, selectedItems) {
        var len = selectedItems.length;
        if(len === 0) {
            alert("Please select account to rename");
            return;
        } else if(len !== 1) {
           alert("Please select single account to rename");
           return;
       }

       $scope.accountToRename = selectedItems[0];
       $scope.itemsMessage = "one item - " + $scope.accountToRename.name;

       $scope.filterType = "accounts";

       $scope.$emit("$openPopup","accountNamePopup","btn-more-accountsTbl" , {lockDown:true} );
       $('#' + targetElId).addClass('open');
       $scope.$root.updateScroll('#accountNamePopup .nano');

    }

    $scope.openMoveAccountDlg = function(targetElId, selectedItems) {
        var len = selectedItems.length;
        if(len === 0) {
            alert("Please select items to move");
            return;
        }
        $scope.itemsMessage = len === 1?"one item - ": len + " items - ";
        $scope.accountToMove = [];
        var i = 0;
        selectedItems.forEach(function(item){
            $scope.accountToMove.push(item.id);
            $scope.itemsMessage += item.name;
            i++;
            if(i == selectedItems.length - 1) {
                $scope.itemsMessage += " and ";
            }
            else if(i < selectedItems.length - 1) {
                $scope.itemsMessage += ", ";
            }
        });
        $scope.filterType = "accounts";


        $scope.$emit("$openPopup","accountOptions","btn-more-accountsTbl" , {lockDown:true} );
        $('#' + targetElId).addClass('open');

        store.fetch({
            method: 'POST',
            path: "/accounts?accountId=" + $scope.params.accountId+"&showMe=true&onlyReseller=true&ignoreIds="+$scope.accountToMove+"&viewType=SimpleList",
            data: {dateField:"",fromDate:0,toDate:0,from:0,limit:1000,orders:[{path:"name",dir:"ACS"}],type:"Account"},
            dataObj: 'dataConfig',
            success: function (data) {
                if(data && data.items) {
                    $scope.$apply(function() {
                        $scope.resellerAccounts = data.items;
                    });

                    $scope.$root.updateScroll('#accountOptions .nano');
                }
            }
        });



    };

    $scope.closeFilterDlg = function(targetElId) {
        $scope.$emit("$closePopup","accountOptions");
        $('#' + targetElId).removeClass('open');
    };

    $scope.closeAccountRenameDlg = function(targetElId) {
            $scope.$emit("$closePopup","accountNamePopup");
            $('#' + targetElId).removeClass('open');
        };

    $scope.moveAccounts = function(account){
        $scope.closeFilterDlg();
        store.save({
            path: "/moveAccounts",
            data: {"accountsToMove" : $scope.accountToMove,
                "newParentAccountId": account.id
            },
            dataObj: 'json',
            success: function(data) {
                $scope.$root.handleServerResponse(data, "", $filter('capitalize')($scope.itemsMessage) + " moved successfully");
                $scope.datamodified = new Date().getTime();
            }
        });
    };

    $scope.renameAccount = function(accountNewName, accountResetPasswords){
        $scope.closeAccountRenameDlg();
        store.save({
            path: "/renameAccount",
            data: {"accountToRename" : $scope.accountToRename.id,
                "accountNewName": accountNewName,
                "shouldResetUsersPasswords": accountResetPasswords
            },
            dataObj: 'json',
            success: function(data) {
                $scope.$root.handleServerResponse(data, "", $filter('capitalize')($scope.itemsMessage) + " renamed to " + accountNewName + " successfully");
                $scope.datamodified = new Date().getTime();
            }
        });
    };

    $scope.openVlanDlg = function(targetElId, selectedItems) {
        var len = selectedItems.length;
        if(len === 0) {
            alert("Please select items to set VLAN");
            return;
        }
        if(len > 1) {
            alert("Please select only one item for this operation");
            return;
        }
        $scope.itemsMessage = len === 1?"one item - ": len + " items - ";
        $scope.accountToMove = [];
        var item = selectedItems[0];
        $scope.accountToMove.push(item.id);
        $scope.itemsMessage += item.name;
        $scope.vlanValue = item.internalVlan;
        $scope.filterType = "accounts";
        $scope.$emit("$openPopup","accountVlan","btn-more-accountsTbl", {lockDown:true} );
        $('#' + targetElId).addClass('open');
    };

    $scope.crossConnectTypeOptions = [
        {
            key: 'VRF',
            value: 'VRF'
        },
        {
            key: 'Layer-2',
            value: 'LAYER2'
        }
    ];

    $scope.crossConnectType = {};

    function getAccountCrossConnectData(onSuccess,accountId) {
        $scope.accountCrossConnect.isParentLayer2 = false;
        store.fetch({
            method : 'GET',
            url : '/getAccountCrossConnectData?accountId='+accountId,
            success: function(data) {
                if(data && data.accountType== 'REGULAR' && data.parentAccountType && data.parentAccountType == 'RESELLER'
                    && data.parentCrossConnectType && data.parentCrossConnectType== 'LAYER2' ){
                    $scope.accountCrossConnect.isParentLayer2 = true;
                    if(data.accountInternalVlan){
                        $scope.intVlan = data.accountInternalVlan;
                    }
                    $scope.$apply();
                }
                onSuccess(data);
            }
        });
    }

    $scope.openCrossConnectDlg = function(targetElId, selectedItems) {
        var len = selectedItems.length;
        if(len === 0) {
            alert("Please select items to set VLAN");
            return;
        }
        if(len > 1) {
            alert("Please select only one item for this operation");
            return;
        }
        $scope.itemsMessage = len === 1?"one item - ": len + " items - ";
        $scope.accountToMove = [];
        var item = selectedItems[0];
        $scope.ccAccount = item.id;
        $scope.itemsMessage += item.name;
        $scope.extVlan = item.externalVlan;
        $scope.intVlan = item.internalVlan;
        $scope.catoIp = item.catoPrivateIp;
        $scope.vrfIp = item.vrfPrivateIp;


        $scope.accountCrossConnect.extVlan = item.externalVlan;
        $scope.accountCrossConnect.intVlan = item.internalVlan;
        $scope.accountCrossConnect.catoIp = item.catoPrivateIp;
        $scope.accountCrossConnect.vrfIp = item.vrfPrivateIp;

        $scope.accountCrossConnect.crossConnectType = item.crossConnectType;
        $scope.accountCrossConnect.ispIpRange = item.ispIpRange;
        $scope.filterType = "accounts";
        if ((item.accountType === 'REGULAR') && (item.externalVlan)) {
            getAccountCrossConnectData(function () {
                $scope.$emit("$openPopup","accountCrossConnect","btn-more-accountsTbl", {lockDown:true} );
            },item.id);
        }
        else if (item.accountType === 'RESELLER') {
            $scope.$emit("$openPopup","accountVlan","btn-more-accountsTbl", {lockDown:true} );
        }
        else {
            alert(item.name + " is not applicable for Cross-Connect settings");
        }
        $('#' + targetElId).addClass('open');
    };

    $scope.closeVlanDlg = function(targetElId) {
        $scope.$emit("$closePopup","accountVlan");
        $('#' + targetElId).removeClass('open');
    };

    $scope.closeCrossConnect = function(targetElId) {
        $scope.$emit("$closePopup","accountCrossConnect");
        $('#' + targetElId).removeClass('open');
    };

    $scope.removeVlan = function(selectedItems) {
        $scope.accountToDeleteVlan = [];
        selectedItems.forEach(function(item){
            $scope.accountToDeleteVlan.push(item.id);
        });
        store.save({
            path: "/removeAccountVlan",
            data: {"accountsToDelete" : $scope.accountToDeleteVlan
            },
            dataObj: 'json',
            success: function(data) {
                $scope.$root.handleServerResponse(data, "",$filter('capitalize')($scope.itemsMessage) + " set VLAN successfully");
                $scope.datamodified = new Date().getTime();
                $scope.vlanValue = null;
            }
        });
    };


    $scope.setVlan = function() {
        $scope.closeVlanDlg();
        store.save({
            path: "/setAccountVlan",
            data: {"accountsToUpdate" : [$scope.ccAccount],
                "vlanId": $scope.accountCrossConnect.extVlan,
                "crossConnectType": $scope.accountCrossConnect.crossConnectType? $scope.accountCrossConnect.crossConnectType: $scope.crossConnectType,
                "ispIpRange":$scope.accountCrossConnect.ispIpRange

            },
            dataObj: 'json',
            success: function(data) {
                $scope.$root.handleServerResponse(data, "", $filter('capitalize')($scope.itemsMessage) + " set VLAN successfully");
                $scope.datamodified = new Date().getTime();
                $scope.vlanValue = null;
                if(data.status == 'OK' && $scope.tableConfig.selectedItems.length == 1){
                    $scope.tableConfig.selectedItems[0].externalVlan = $scope.accountCrossConnect.extVlan;
                    $scope.tableConfig.selectedItems[0].crossConnectType = $scope.accountCrossConnect.crossConnectType;
                }
            }
        });
    };

    $scope.accountCrossConnect = {};

    $scope.setCrossConnect = function() {
        $scope.closeCrossConnect();
        var crossConnectSettings ={selectedAccountId:$scope.ccAccount,internalVlan: $scope.accountCrossConnect.intVlan, catoPrivateIp:$scope.accountCrossConnect.catoIp, vrfPrivateIp:$scope.accountCrossConnect.vrfIp};
        store.save({
            path: "/setAccountCC",
            data: crossConnectSettings,
            dataObj: 'json',
            queryParams :{
                accountId: $state.params.accountId
            },
            success: function(data) {
                $scope.$root.handleServerResponse(data, "", $filter('capitalize')($scope.itemsMessage) + " set Cross Connect successfully");
                $scope.datamodified = new Date().getTime();
                $scope.vlanValue = null;
                if(data.status == 'OK' && $scope.tableConfig.selectedItems.length == 1){
                    $scope.tableConfig.selectedItems[0].externalVlan = $scope.accountCrossConnect.extVlan;
                    $scope.tableConfig.selectedItems[0].internalVlan = $scope.accountCrossConnect.intVlan ;
                    $scope.tableConfig.selectedItems[0].catoPrivateIp = $scope.accountCrossConnect.catoIp;
                    $scope.tableConfig.selectedItems[0].vrfPrivateIp = $scope.accountCrossConnect.vrfIp ;
                }


            }
        });
    };


    function changeView(newView) {
        $scope.tableConfig.viewType = newView;
        switch (newView){
            case "List":
                delete $scope.tableConfig.watchDate;
                delete $scope.tableConfig.toDate;
                delete $scope.tableConfig.fromDate;
                $scope.tableConfig.fields = [
                    {"label":"Name","path":"name","template":"<a class='link-simple' ui-state='item.mainPageLink' ui-state-params='item.mainPageParams'>{{item.name}}</a>"},
                    {"label":"Type","path":"accountType","template":"<span>{{item.accountType|capitalize}}</span>"},
                    {"label":"Configured Sites","class":"sites", "path":"sitesCount","template":"<a ui-sref='app.sites({accountId: item.id})'>{{item.sitesCount}}</a>"},
                    {"label":"Configured Users", "class":"users", "path":"accessloginsCount","template":"<a  ui-sref='app.logins({accountId: item.id})'>{{item.accessloginsCount}}</a>"},
                    {"label":"License","path":"currentLifeCycle","template":"<div>{{item.currentLifeCycle}}</div>"},
                    {"label":"Expire On","path":"currentLifeCycleExpiration","template":"<div>{{item.expireTime}}</div>"},
                    {"label":"Manage by","path":"parentName","template":"{{item.parentName}}"}];
                if (isSmallWindow())  {
                    $scope.tableConfig.fields[2].label = "Sites";
                    $scope.tableConfig.fields[3].label = "Users";
                }
                $scope.tableConfig.pageSize =  50;
                $scope.tableConfig.sortList = [{sortField: "name", sortDir: "ASC" }];
                break;
            case "Card":
                delete $scope.tableConfig.watchDate;
                delete $scope.tableConfig.toDate;
                delete $scope.tableConfig.fromDate;
                $scope.tableConfig.fields = [
                    {"label":"Name","path":"name","template":"<span class='link-simple'>{{item.name}}</span>"},
                    {"label":"Type","path":"accountType","template":"<span>{{item.accountType|capitalize}}</span>"},
                    {"label":"Active Sites (Last 72h)","path":"sitesActive","template":"<a ui-sref='app.monitorSites({accountId: item.id})'>{{item.sitesActive}}</a>"},
                    {"label":"Sites","path":"sitesCount","template":"<a ui-sref='app.sites({accountId: item.id})'>{{item.sitesCount}}</a>"},
                    {"label":"Active Users (Last 72h)","path":"accessloginsActive","template":"<a  ui-sref='app.monitorLogins({accountId: item.id})'>{{item.accessloginsActive}}</a>"},
                    {"label":"Users","path":"accessloginsCount","template":"<a  ui-sref='app.logins({accountId: item.id})'>{{item.accessloginsCount}}</a>"},
                    {"label":"Current Throughout","path":"throughput","template":"<div>{{item.throughput}}</div>"},
                    {"label":"Volume","path":"volume","template":"<div>{{item.volume}}</div>"},
                    {"label":"License","path":"currentLifeCycle","template":"<div>{{item.currentLifeCycle}}</div>"},
                    {"label":"Expire On","path":"currentLifeCycleExpiration","template":"<div>{{item.expireTime}}</div>"},
                    {"label":"Sites License","path":"sitesLicenseCount","template":"{{item.sitesLicenseCount}}"},
                    {"label":"Users License","path":"accessloginsLicenseCount","template":"{{item.accessloginsLicenseCount}}"},
                    {"label":"Total Bandwidth","path":"totalBandwidth","template":"{{item.totalBandwidth}}"},
                    {"label":"Manage by","path":"parentName","template":"{{item.parentName}}"}];
                $scope.tableConfig.pageSize =  10;
//                $scope.tableConfig.sortList = [{sortField: "throughput", sortDir: "DESC" }];
                $scope.tableConfig.sortList = [{sortField: "name", sortDir: "ASC" }];
                break;
            case "Detail":
                $scope.tableConfig.watchDate = true;
                $scope.tableConfig.fields = [
                    {"label":"Name","path":"name","template":"<span class='link-simple'>{{item.name}}</span>"},
                    {"label":"Type","path":"accountType","template":"<span>{{item.accountType|capitalize}}</span>"},
                    {"label":"Active Sites (Last 72h)","path":"sitesActive","template":"<a ui-sref='app.monitorSites({accountId: item.id})'>{{item.sitesActive}}</a>"},
                    {"label":"Sites","path":"sitesCount","template":"<a ui-sref='app.sites({accountId: item.id})'>{{item.sitesCount}}</a>"},
                    {"label":"Active Users (Last 72h)","path":"accessloginsActive","template":"<a  ui-sref='app.monitorLogins({accountId: item.id})'>{{item.accessloginsActive}}</a>"},
                    {"label":"Users","path":"accessloginsCount","template":"<a  ui-sref='app.logins({accountId: item.id})'>{{item.accessloginsCount}}</a>"},
                    {"label":"License","path":"currentLifeCycle","template":"<div>{{item.currentLifeCycle}}</div>"},
                    {"label":"Expire On","path":"currentLifeCycleExpiration","template":"<div>{{item.expireTime}}</div>"},
                    {"label":"Sites License","path":"sitesLicenseCount","template":"{{item.sitesLicenseCount}}"},
                    {"label":"Users License","path":"accessloginsLicenseCount","template":"{{item.accessloginsLicenseCount}}"},
                    {"label":"Total Bandwidth","path":"totalBandwidth","template":"{{item.totalBandwidth}}"},
                    {"label":"Manage by","path":"parentName","template":"{{item.parentName}}"}];
                $scope.tableConfig.pageSize =  3;
                $scope.tableConfig.sortList = [{sortField: "name", sortDir: "ASC" }];
                break;
        }
        if(isSystemLogin){
            // add fields that are relevant only in admin mode
            $scope.tableConfig.fields.splice(2, 0, {"label":"Production?","path":"accountProductionType","template":"<svg class='{{tableConfig.getProductionClass(item.accountProductionType)}}'><use xlink:href='' ng-href='{{tableConfig.getProductionIcon(item.accountProductionType)}}'></use></svg>"});
            $scope.tableConfig.fields.splice(3, 0, {"label":"Release Group","path":"releaseGroup","template":"<span>{{item.releaseGroup | capitalize}}</span>"});
        }



        function isSmallWindow() {
            return $window.width() < 1500;
        }

        function windowResize() {
            if (isSmallWindow()) {
                $('.sites').text('Sites');
                $('.users').text('Users');
            }
            else{
                $('.sites').text('Configured Sites');
                $('.users').text('Configured Users');
            }
        }

        $window.on('resize', windowResize);

        $scope.$on('$destroy', function () {
            $(window).off('resize', windowResize);
        });

    }
}
